import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { apiUrl, apitoken, server } from "../Constants";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useDispatch, useSelector } from "react-redux";
import { httpClient } from "../utils/HttpClient";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    margin: 10,
    backgroundColor: "grey",
    textAlign: "center",
    paddingTop: 10,
  },
});

export default function FilesUploadComponent({ handleUpload, headerId }) {
  const classes = useStyles();
  const [errors, setErrors] = useState("");
  const [files, setFiles] = useState(null);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    setErrors(``);
    fileRejections.forEach((file) => {
      file.errors.forEach((err) => {
        if (err.code === "file-too-large") {
          setErrors(`Error: ${err.message}`);
        }

        if (err.code === "file-invalid-type") {
          setErrors(`Error: ${err.message}`);
        }
      });
    });

    var formData = new FormData();

    formData.append("PRHIDX", headerId);
    formData.append("ATT_TYPE", 1);

    for (const file of acceptedFiles) {
      formData.append("ATT_FILENAME", file, file.name);
    }

    httpClient
      .post(`${apiUrl}/purchase-request/attach-file`, formData)
      .then((res) => {
        handleUpload();
      });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/jpeg, application/pdf",
    maxSize: 1000000,
    multiple: false,
  });
  return (
    <Card className={classes.root}>
      <CardContent>
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <FileCopyIcon style={{ fontSize: 50 }} />
          {isDragActive ? (
            <p>Drop the files here ...</p>
          ) : (
            <p>Drag 'n' drop some files here, or click to select files</p>
          )}
          <p style={{ color: red[700] }}>{errors}</p>
        </div>
      </CardContent>
    </Card>
  );
}
